import { FC, useMemo } from 'react';
import { Log } from '../../../types';
import { WbEditor } from '../../Editors/WbEditor';
import { stringifyLogs } from '../WbLogsCard/utils';

interface Props {
  text?: string;
  logs?: Log[];
  language?: string;
}

export const WbLogsViewer: FC<Props> = ({ text, logs, language }) => {
  const logText = useMemo(() => {
    const removeANSIColorRegExp =
      // eslint-disable-next-line no-control-regex
      /[\u001b\u009b][[()#;?]*(?:[0-9]{1,4}(?:;[0-9]{0,4})*)?[0-9A-ORZcf-nqry=><]/g;
    let res = text ?? 'No data available';
    if (logs && logs.length > 0 && !text) res = stringifyLogs(logs);
    return res.replace(removeANSIColorRegExp, '');
  }, [text, logs]);
  const linesWithSeverities = useMemo(() => {
    return logs
      ?.map((item, index) => (item.severity === 'ERROR' ? index + 1 : 0))
      .filter(index => !!index);
  }, [logs]);
  return (
    <WbEditor
      theme="white"
      value={logText}
      options={{ readOnly: true, minimap: { enabled: false } }}
      linesWithSeverities={linesWithSeverities}
      language={language ?? 'plaintext'}
    />
  );
};
